import styled, { css } from 'styled-components/macro';

export const TableRowSpanDot = styled.span`
  height: 5px;
  width: 5px;
  background-color: ${props => props.theme[props.color]};
  border-radius: 50%;
  margin-top: 3px;
  display: inline-block;
  vertical-align: center;
`;

export const DetailedRowDiv = styled.div`
  padding: 20px 0 20px 0;
  border-top: 2px solid white;
`;

export const DetailedRowP = styled.p`
  font-size: 12px;
`;

export const DetailedRowH6 = styled.h6`
  /*  */
`;

export const DetailedRowTd = styled.td`
  padding-left: 20px;
  ${props =>
    props.capitalize &&
    css`
      text-transform: capitalize;
    `}
  ${props =>
    props.color &&
    css`
      color: ${props => props.theme[props.color]};
    `}
`;
